<template>
  <customModal :containerxl="true" :bodyxl="true" :footerShow="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">{{ isEditMode ? 'Edit Quality Tolerance Limit' : 'Create Quality Tolerance Limit' }}</h4>
    </template>

    <template #body>
      <form>
        <div class="row">

          <!-- SECTION 1: General QTL Information -->
          <div class="col-12 mb-1">
            <h6 class="border-bottom py-1">General QTL Information</h6>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">QTL ID <sup ><i class="fa fa-asterisk required"></i></sup></label>
            <input type="text" class="form-control" v-model="form.qtlId" :class="{ 'errorClass': errors.qtlId }" :disabled="isEditMode" />
            <div class="errorClass" v-if="errors.qtlId">{{ errors.qtlId }}</div>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">CTQ ID</label>
            <input type="text" class="form-control" v-model="form.ctqId" disabled />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">CTQ Factor</label>
            <input type="text" class="form-control" v-model="form.ctqFactor" disabled />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">CTQ Category</label>
            <input type="text" class="form-control" v-model="form.ctqCategory" disabled />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Quality Metric <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.qualityMetric" :class="{ 'errorClass': errors.qualityMetric }" />
            <div class="errorClass" v-if="errors.qualityMetric">{{ errors.qualityMetric }}</div>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Responsible Owner</label>
            <input type="text" class="form-control" v-model="form.responsibleOwner" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Monitoring Frequency</label>
            <input type="text" class="form-control" v-model="form.monitoringFrequency" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Review Period</label>
            <input type="text" class="form-control" v-model="form.reviewPeriod" />
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Status</label>
            <select class="form-control" v-model="form.status">
              <option value="">Select Option</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div class="col-lg-12 mb-2">
            <label class="form-label mb-0">QTL Description</label>
            <textarea class="form-control custom-textarea" rows="2" v-model="form.qtlDescription"></textarea>
          </div>

          <!-- SECTION 2: Threshold Details -->
          <div class="col-12 mt-3 mb-2">
            <h6 class="border-bottom py-1">Threshold Details</h6>
          </div>

          <div class="col-lg-4 mb-2">
            <label class="form-label mb-0">Threshold Type</label>
            <input type="text" class="form-control" v-model="form.thresholdType" />
          </div>

          <div class="col-lg-8 mb-2">
            <label class="form-label mb-0">QTL Acceptable Limits</label>
            <input type="text" class="form-control" v-model="form.qtlAcceptableLimits" />
          </div>

          <div class="col-lg-6 mb-2">
            <label class="form-label mb-0">QTL Calculation Logic <sup ><i class="fa fa-asterisk required"></i></sup></label>
            <textarea class="form-control custom-textarea" rows="2" v-model="form.qtlCalculationlogic"  :class="{ 'errorClass': errors.qtlCalculationlogic }"></textarea>
            <div class="errorClass" v-if="errors.qtlCalculationlogic">{{ errors.qtlCalculationlogic }}</div>
          </div>

          <div class="col-lg-6 mb-2">
            <label class="form-label mb-0">Escalation Action</label>
            <textarea class="form-control custom-textarea" rows="2" v-model="form.escalationAction"></textarea>
          </div>

          <!-- SECTION 3: Threshold Levels -->
          <div class="col-12 mt-3 mb-2 d-flex justify-content-between align-items-center border-bottom ">
            <h6 class="py-0">Threshold Levels</h6>
            <div class="position-relative cursor-pointer">
              <img src="@/assets/img/create.png" width="17" @click="addThreshold" alt="Add Threshold" />
              <div class="tool-tip">Add Threshold</div>
            </div>
          </div>

          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead class="table-light">
                  <tr>
                    <th>Min</th>
                    <th>Max</th>
                    <th>Label</th>
                    <th>Color</th>
                    <th class="text-center" style="width: 100px;">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(t, i) in form.thresholds" :key="i">
                    <td>
                      <input type="number" class="form-control" v-model.number="t.min" />
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model.number="t.max" />
                    </td>
                    <td>
                      <input type="text" class="form-control" v-model="t.label" />
                    </td>
                    <td>
                      <select class="form-control" v-model="t.color">
                        <option value="">Select Color</option>
                        <option value="Green">Green</option>
                        <option value="Amber">Amber</option>
                        <option value="Red">Red</option>
                      </select>
                    </td>
                    <td class="text-center">
                      <i class="fa fa-trash edit-delete text-danger cursor-pointer" @click="removeThreshold(i)"></i>
                    </td>
                  </tr>
                  <tr v-if="!form.thresholds.length">
                    <td colspan="5" class="text-center text-muted py-3">No Threshold Levels added. Click the '+' icon above to add one.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </form>
    </template>

    <template #footer>
      <div class="d-flex justify-content-end align-items-center">
        <div v-if="submitting" class="spinner-border text-primary spinner-border-sm me-3" role="status">
          <span class="visually-hidden">Saving...</span>
        </div>
        <button class="cancel_btn py-1 px-4 mx-2" :disabled="submitting" @click.prevent="clear">
          Clear
        </button>
        <button class="save_btn py-1 px-4" :disabled="submitting" @click.prevent="saveClicked">
          Save
        </button>
      </div>
    </template>
  </customModal>
</template>

<script src="./manageQtlModal.js"></script>

<style scoped>
.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #3d4b63;
  margin-bottom: 0;
}
.custom-textarea {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px;
  resize: vertical;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 4px;
}
.is-invalid {
  border-color: #dc3545 !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>